import { Component, OnInit, OnDestroy } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faPrint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import jsPDF from "jspdf";

@Component({
  selector: "app-factulis",
  templateUrl: "./factulis.component.html",
  styleUrls: ["./factulis.component.css"],
})
export class FactulisComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoPrn = faPrint;
  icoFac = faFileAlt;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  prifec: string;
  ultfec: string;

  expandedIndex: number | null = null;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);
    this.cargaTabla();
  }

  ngOnDestroy(): void {
    // NO OLVIDAR DESUSCRIBIR EL EVENTO
    this.dtTrigger.unsubscribe();
  }
  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargaTabla(): void {
    this.dtOptions = {
      dom: "Blfrtip",
      buttons: [],
      ordering: false,
      language: {
        thousands: ".",
        decimal: ",",
        emptyTable: "No hay datos disponibles en la tabla",
        info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando de 0 a 0 de 0 registros",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        infoPostFix: "",
        lengthMenu: "Mostrar _MENU_ registros",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "No se encontraron registros coincidentes",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior",
        },
        aria: {
          sortAscending: ": activar para ordenar por columna ascendente",
          sortDescending: ": activar para ordenar por columna descendente",
        },
      },
    };
    this.cargaDatos();
  }

  cargaDatos() {
    this.resul = true;
    this.datosTabla = [];
    this.srvCentral
      .consulFactura(0, this.prifec, this.ultfec)
      .subscribe((datos) => {
        if (datos[0].facFech === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].facErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          this.datosTabla = [];
          for (const datitem of datos) {
            this.datosTabla.push(datitem);
          }
        }
        this.dtTrigger.next();
      });
  }

  volver(): void {
    this.router.navigate(["/factura"]);
  }

  documento(i: number): void {
    this.resul = true;
    this.srvCentral
      .documFactura(
        this.datosTabla[i].facEjer,
        this.datosTabla[i].facSeri,
        this.datosTabla[i].facNume
      )
      .subscribe((datos) => {
        if (datos[0].facFech === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].facErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          const tx = this.srvCentral.saca(datos[0].facFech);
          const url = this.srvCentral.UrlCave + "/" + tx;
          window.open(url, "_blank");
        }
      });
  }

  toggleCard(i: number) {
    this.expandedIndex = this.expandedIndex === i ? null : i;
  }
  /*
  descargarPDF(i: number) {
    const item = this.datosTabla[i]; // tomamos el registro directamente
    if (!item) return;

    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text(`Factura: ${item.facSeri}-${item.facNume}`, 20, 20);
    doc.setFontSize(12);
    doc.text(`Fecha: ${item.facFech}`, 20, 30);
    doc.text(`Cliente: ${item.facCliente}`, 20, 40);
    doc.text(`Importe: ${item.facImpo}`, 20, 50);

    // Añadir más campos de item según necesites
    let y = 60;
    for (const key in item) {
      if (
        item.hasOwnProperty(key) &&
        !["facSeri", "facNume", "facFech", "facCliente", "facImpo"].includes(
          key
        )
      ) {
        doc.text(`${key}: ${item[key]}`, 20, y);
        y += 10;
      }
    }

    doc.save(`Factura_${item.facSeri}-${item.facNume}.pdf`);
  }
    */
  descargarPDF(i: number): void {
    // Validar índice
    if (!this.datosTabla || i >= this.datosTabla.length || i < 0) {
      console.error("Índice inválido");
      return;
    }

    const item = this.datosTabla[i];

    // Validar datos
    if (!item.facFech || !item.facSeri || !item.facNume) {
      const modalRef = this.modalService.open(AvisosComponent);
      modalRef.componentInstance.datAviso = {
        tit: "ERROR",
        tex: "Datos de factura incompletos.",
        tip: 2,
        btcan: "",
        btno: "",
        btsi: "Aceptar",
      };
      return;
    }

    // Formatear fecha si es necesario
    const fec1 = this.srvCentral.cadenaFecha(this.prifec);
    const fec2 = this.srvCentral.cadenaFecha(this.ultfec);

    if (fec1 > fec2) {
      const modalRef = this.modalService.open(AvisosComponent);
      modalRef.componentInstance.datAviso = {
        tit: "FECHAS ERRÓNEAS",
        tex: "Fecha inicial posterior a fecha final",
        tip: 1,
        btcan: "",
        btno: "",
        btsi: "Aceptar",
      };
      return;
    }

    // Obtener nombre del cliente
    const clienteNombre =
      this.srvCentral.datosIden?.UsuNom || "Cliente desconocido";

    // Crear PDF con jsPDF
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Estilos
    const titleColor: [number, number, number] = [30, 60, 90];
    const textColor: [number, number, number] = [50, 50, 50];
    const lineColor: [number, number, number] = [200, 200, 200];
    const headerColor: [number, number, number] = [240, 240, 240];

    // Configurar fuente y color
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(...titleColor);
    doc.text(`Listado de Facturas`, 20, 20);

    // Información del cliente y periodo
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.setTextColor(...textColor);
    doc.text(`Cliente: ${clienteNombre}`, 20, 30);
    doc.text(`Periodo: ${this.prifec} - ${this.ultfec}`, 20, 40);

    // Línea separadora
    doc.setDrawColor(...lineColor);
    doc.line(20, 45, 200, 45);

    // Encabezados de tabla
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setFillColor(...headerColor);
    doc.rect(20, 50, 40, 8, "F"); // Factura
    doc.rect(60, 50, 40, 8, "F"); // Fecha
    doc.rect(100, 50, 30, 8, "F"); // Ventas
    doc.rect(130, 50, 25, 8, "F"); // IVA
    doc.rect(155, 50, 35, 8, "F"); // Total Neto

    doc.setTextColor(...textColor);
    doc.text("Factura", 22, 55);
    doc.text("Fecha", 62, 55);
    doc.text("Ventas €", 102, 55);
    doc.text("IVA €", 132, 55);
    doc.text("Total €", 157, 55);

    // Línea debajo de encabezados
    doc.setDrawColor(...lineColor);
    doc.line(20, 58, 200, 58);

    // Datos de la factura específica
    let y = 65;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...textColor);

    const factura = `${item.facSeri}-${item.facNume}`;
    const fecha = item.facFech || "Sin fecha";
    const ventas = item.facVtas ? parseFloat(item.facVtas).toFixed(2) : "0.00";
    const iva = item.facIvas ? parseFloat(item.facIvas).toFixed(2) : "0.00";
    const total = item.facNeto ? parseFloat(item.facNeto).toFixed(2) : "0.00";

    // Alinear texto a la derecha para números
    doc.text(factura, 22, y);
    doc.text(fecha, 62, y);
    doc.text(ventas, 128, y, { align: "right" }); // Ventas
    doc.text(iva, 153, y, { align: "right" }); // IVA
    doc.text(total, 188, y, { align: "right" }); // Total

    // Línea después de la fila
    doc.setDrawColor(...lineColor);
    doc.line(20, y + 3, 200, y + 3);

    // Pie de página
    y += 10;
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(`Generado el: ${new Date().toLocaleString()}`, 20, y);

    // Nombre del archivo
    const nombreArchivo = `Factura_${factura}_${this.prifec.replace(
      /\//g,
      "-"
    )}_${this.ultfec.replace(/\//g, "-")}.pdf`;

    // Guardar
    doc.save(nombreArchivo);
  }
}
